import React, { useState } from 'react'

import Bag from 'components/popup/group-setup/bag'
import DynamicLink from 'components/popup/group-setup/link'
import { ConnectionData } from 'interfaces/connection'
import { getCurrentConnectionIssue } from 'lib/connection/connection'
import './style.scss'

interface DemoBag {
  id: string
  name: string
  color: string
  connection: ConnectionData
}

const demoBags: DemoBag[] = [
  {
    id: 'preview-good',
    name: 'Bag 1',
    color: '#2C89C8',
    connection: {
      latestWifiStrength: -62,
      averageReceivedPackets: 20,
      latestRebootCount: 1,
    },
  },
  {
    id: 'preview-warning',
    name: 'Bag 2',
    color: '#70ED99',
    connection: {
      latestWifiStrength: -86,
      averageReceivedPackets: 20,
      latestRebootCount: 1,
    },
  },
  {
    id: 'preview-offline',
    name: 'Bag 3',
    color: '#FF7733',
    connection: {
      latestWifiStrength: -92,
      averageReceivedPackets: 0,
      latestRebootCount: 0,
    },
  },
]

const GroupWorkoutSetupPreview: React.FC = () => {
  const [disabledBags, setDisabledBags] = useState<string[]>([])

  const toggleBag = (bagId: string) => {
    setDisabledBags((currentDisabledBags) =>
      currentDisabledBags.includes(bagId)
        ? currentDisabledBags.filter((currentBagId) => currentBagId !== bagId)
        : [...currentDisabledBags, bagId],
    )
  }

  return (
    <div className="group-setup-preview">
      <div className="popupBackground group-setup-preview__background">
        <div className="popupWrapper setup-container group-setup-preview__panel">
          <div className="group-setup-duration">LOCAL PREVIEW</div>
          <div className="group-setup-title" style={{ textAlign: 'center' }}>
            Group setup bag connection states
          </div>
          <div className="group-setup-subtitle" style={{ textAlign: 'center' }}>
            Demo page for the three statuses. Click a bag to preview the disabled opacity.
          </div>

          <div className="group-setup-preview__bags">
            {demoBags.map((bag) => {
              const status = getCurrentConnectionIssue(bag.connection).status
              const isEnabled = !disabledBags.includes(bag.id)

              return (
                <div key={bag.id} className="group-setup-preview__bag">
                  <button
                    type="button"
                    className="group-setup-preview__bag-button"
                    aria-label={`Toggle ${bag.name}`}
                    onClick={() => toggleBag(bag.id)}
                  >
                    <Bag color={bag.color} opacity={isEnabled ? 1 : 0.4} />
                  </button>
                  <DynamicLink status={status} />
                  <div className="group-setup-preview__bag-name">{bag.name}</div>
                  <div className="group-setup-preview__bag-details">
                    wifi {bag.connection.latestWifiStrength}
                    <br />
                    packets {bag.connection.averageReceivedPackets}
                    <br />
                    reboots {bag.connection.latestRebootCount}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GroupWorkoutSetupPreview
